import { REQUEST_STATUS } from "../../enum"
import EPGParser from "./epg-parser"
import EpgProgram from "./epg-program"
import EPGUtility from "./epg-utility"
import EPGProgramUI from "./views/epg-program-ui"
import EPGTimelineUI from "./views/epg-timeline-ui"
import { PromiseResolver } from "../grid/row-model"
import EPGConfig from "./epg-config"

export default class EpgChannel {

    id = ''
    repeatPrograms = 'false'
    displayName = ''
    image = ''
    epgUrl = ''
    squareIcon = ''
    main_picture = ''
    programList: EpgProgram[] = []
    name = ''
    rowName = ''
    fetchStatus: REQUEST_STATUS = REQUEST_STATUS.NONE
    fetchPromise:PromiseResolver = new PromiseResolver()

    async fetchEpgPrograms(dateRange:any, multiData=null): Promise<EpgChannel> {
        if (this.epgUrl && this.epgUrl !== '') {
            this.fetchStatus = REQUEST_STATUS.FETCHING
            try {
                let data = multiData
                if(!multiData) {
                    const results = await fetch(this.epgUrl)
                    data = await results.json()
                }
                await EPGParser.parseEPGData(this, data, dateRange)
                this.fetchStatus = REQUEST_STATUS.OK
                this.fetchPromise.resolve(this)
            } catch (e) {
                this.fetchStatus = REQUEST_STATUS.FAIL
                this.fetchPromise.resolve(this)
            }
        }
        return this
    }

    createPrograms(dateRange: { startDate: Date, endDate: Date }, channelIndex?: any, windowStart?: Date, windowEnd?: Date): any[] {
        const wStart = windowStart || dateRange.startDate
        const wEnd = windowEnd || dateRange.endDate
        let filteredItems: any[] = []

        this.programList.forEach((program, index) => {
            if (program.end_timeObj > wStart && program.start_timeObj < wEnd) {
                const pos = EPGUtility.getProgramPosition(program, dateRange, EPGConfig.pixelPerHour, 1)
                filteredItems.push({
                    x: pos.x,
                    h: EPGConfig.ChannelRowHeight,
                    w: pos.w,
                    type: EPGProgramUI,
                    justify: 'left',
                    fixed: true,
                    index: index,
                    channelIndex: channelIndex,
                    st: program.start_timeObj,
                    et: program.end_timeObj,
                    title: program.title,
                    image: program.image == '' ? this.image : program.image,
                    rating: program.rating,
                    category: program.category,
                    description: program.description || ''
                })
            }
        })

        if (filteredItems.length === 0) {
            filteredItems = this._createWindowedDummies(dateRange, channelIndex, wStart, wEnd)
        } else {
            for (let i = 0; i < filteredItems.length - 1; i++) {
                const item = filteredItems[i]
                const nextItem = filteredItems[i + 1]
                if (item.x + item.w < nextItem.x) {
                    item.w = nextItem.x - item.x
                }
            }
            const lastItem = filteredItems[filteredItems.length - 1]
            const minutesFromRangeStart = (wEnd.getTime() - dateRange.startDate.getTime()) / (1000 * 60)
            const wEndPixel = (EPGConfig.pixelPerHour / 60) * minutesFromRangeStart
            if (lastItem.x + lastItem.w < wEndPixel) {
                lastItem.w = wEndPixel - lastItem.x
            }
        }

        return filteredItems
    }

    private _createWindowedDummies(dateRange, channelIndex, windowStart: Date, windowEnd: Date): any[] {
        const items = []
        const st = new Date(windowStart)
        st.setMinutes(0, 0, 0)
        let i = 0
        while (st < windowEnd) {
            const et = new Date(st)
            et.setHours(et.getHours() + 1)
            items.push(this.createDummyProgram(new Date(st), new Date(et), dateRange, channelIndex, i))
            st.setHours(st.getHours() + 1)
            i++
        }
        return items
    }

    createDummyProgram(st,et, dateRange, channelIndex, programIndex, fillprogram?:EpgProgram) {

        let program: EpgProgram = fillprogram || new EpgProgram()
        if(!fillprogram) {
            program.start_timeObj = st
            program.end_timeObj = et
            program.title = 'No Data'
            program.image = this.image
        }
        program.duration = (et - st) / 1000        
        const pos = EPGUtility.getProgramPosition(program, dateRange, EPGConfig.pixelPerHour, 1)
        const filteredItem = {
            x: pos.x,
            h: EPGConfig.ChannelRowHeight,
            w: pos.w,
            type: EPGProgramUI,
            justify: 'left',
            fixed: true,
            index: programIndex,
            channelIndex: channelIndex,
            st: program.start_timeObj,
            et: program.end_timeObj,
            title: program.title,
            image: program.image,
            rating: '',
            category: '',
            description: ''
        }
        return filteredItem
    }

    createTimeline(dateRange) {
        const filteredItems = []
        const startTime = new Date(dateRange.startDate)
        //startTime.setHours(startTime.getHours() - 1)
        for (let i = 0; i < 48; i++) {
            try {
                const st = new Date(startTime)
                const et = new Date(st)
                et.setMinutes(et.getMinutes() + 30,0,0)
                const program: EpgProgram = new EpgProgram()
                program.start_timeObj = st
                program.end_timeObj = et
                program.duration = (et - st) / 1000
                //program.title = EPGUtility.formatAMPM(startTime)
                program.start_time = startTime
                const pos = EPGUtility.getProgramPosition(program, dateRange, EPGConfig.pixelPerHour, 1)
                filteredItems.push({
                    x: pos.x,
                    h: 72,
                    w: pos.w,
                    type: EPGTimelineUI,
                    justify: 'left',
                    fixed: true,
                    index: i,
                    channelIndex: -1,
                    paddingX: 5,
                    st: program.start_timeObj,
                    et: program.end_timeObj,
                    title: program.title
                })
                startTime.setMinutes(st.getMinutes() + 30,0,0)
            } catch (e) {
                //console.log('Timeline on error:', e)
            }
        }
        return filteredItems
    }

    getNowPlayingProgram(currDate) {
        const program = this.programList.find(program => EPGUtility.isPlaying(program.start_timeObj, program.end_timeObj,currDate))
        return program
    }
}

